export const VIDEO_ACCEPT = 'video/mp4,video/quicktime,.mp4,.mov';
export const VIDEO_ACCEPT_SET = new Set(['video/mp4', 'video/quicktime']);
export const MAX_VIDEO_BYTES = 100 * 1024 * 1024;
export const MAX_VIDEO_SECONDS = 900;

const POSTER_MAX_EDGE = 640;

// Read dimensions/duration before upload and capture a best-effort poster frame.
// The object URL is always revoked; a poster failure never blocks the video.
export function readVideoMetaAndPoster(file) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const videoEl = document.createElement('video');
    videoEl.preload = 'metadata';
    videoEl.muted = true;
    videoEl.playsInline = true;
    let settled = false;
    const finish = (result, error) => {
      if (settled) return;
      settled = true;
      URL.revokeObjectURL(objectUrl);
      videoEl.removeAttribute('src');
      videoEl.load();
      if (error) reject(error); else resolve(result);
    };
    videoEl.onloadedmetadata = () => {
      const width = videoEl.videoWidth || null;
      const height = videoEl.videoHeight || null;
      const duration = videoEl.duration;
      const capture = () => {
        let posterDataUrl = null;
        try {
          const w = width || 640;
          const h = height || 360;
          const scale = Math.min(1, POSTER_MAX_EDGE / Math.max(w, h));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(w * scale));
          canvas.height = Math.max(1, Math.round(h * scale));
          canvas.getContext('2d').drawImage(videoEl, 0, 0, canvas.width, canvas.height);
          posterDataUrl = canvas.toDataURL('image/jpeg', 0.85);
        } catch (_) { /* poster is optional */ }
        finish({ width, height, duration, posterDataUrl });
      };
      if (Number.isFinite(duration) && duration > 0) {
        videoEl.onseeked = capture;
        try { videoEl.currentTime = Math.min(0.1, duration); }
        catch { capture(); }
      } else {
        capture();
      }
    };
    videoEl.onerror = () => finish(null, new Error('Could not read video metadata'));
    videoEl.src = objectUrl;
  });
}
